import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

export const schemaOrganization = z.object({
  account_manager: z.string().optional(),
});

export type OrganizationEntity = z.infer<typeof schemaOrganization>;

const organizationResolver: Resolver<OrganizationEntity> = zodResolver(schemaOrganization) as never;

export const organizationFormOptions: UseFormProps<OrganizationEntity> = {
  mode: 'onSubmit',
  resolver: organizationResolver,
};
